import React from 'react';
import cx from 'classnames';

import { InfoBox, InfoBoxVariant } from '@motorway/mw-highway-code/alpha';
import { INFOBOX_VARIANT } from '@motorway/mw-highway-code/enums';

import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';

import styles from './ProfilingInfoBox.module.scss';

export type ProfilingInfoBoxProps = {
  children: React.ReactNode | React.ReactElement;
  className?: string;
  heading?: {
    content: React.ReactNode;
    normalWeight?: boolean;
  };
  showConstantly?: boolean;
  showOnDesktopOnly?: boolean;
  showOnMobileOnly?: boolean;
  variant?: InfoBoxVariant;
}

export const ProfilingInfoBox = ({
  children: content,
  className,
  heading,
  showConstantly,
  showOnDesktopOnly,
  showOnMobileOnly,
  variant = INFOBOX_VARIANT.DEFAULT,
}: ProfilingInfoBoxProps) => {
  const breakpoints = useBreakpoint();
  const tabletBreakpoint = breakpoints.maxWidth.breakpointTablet;

  const shouldRenderContent = content && (
    showConstantly
    || (showOnDesktopOnly && !tabletBreakpoint)
    || (showOnMobileOnly && tabletBreakpoint)
  );

  if (!shouldRenderContent) {
    return null;
  }

  const classNames = cx(styles.component, className);

  const headingContent = heading?.content
    ? <p className={cx({ [styles.normalWeight]: heading?.normalWeight })}>{heading.content}</p>
    : null;

  return (
    <div className={classNames}>
      <InfoBox
        heading={headingContent}
        {...{ content, variant }} />
    </div>
  );
};
